module.exports = __webpack_public_path__ + "img/img39.4dc32dce.svg";